module.exports = __webpack_public_path__ + "img/4.b3aa2fda.jpg";